// 路由预加载 composable
// 在用户 hover 链接时预加载目标路由的 JS chunk，减少导航延迟
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

export function useRoutePreload() {
  if (import.meta.server) return

  const router = useRouter()

  // 预加载指定路由对应的懒加载组件
  const preload = (path: string) => {
    const matched = router.resolve(path)?.matched ?? []
    matched.forEach((record) => {
      const component = record.components?.default
      // 触发动态导入（如果是异步组件）
      if (typeof component === 'function') {
        ;(component as () => Promise<unknown>)().catch(() => {})
      }
    })
  }

  // 监听鼠标悬停，自动预加载 nuxt-link 目标路由
  const bindHoverPreload = (el: HTMLElement) => {
    el.querySelectorAll<HTMLAnchorElement>('a[href]').forEach((anchor) => {
      anchor.addEventListener('mouseenter', () => {
        const href = anchor.getAttribute('href')
        if (href && href.startsWith('/')) {
          preload(href)
        }
      }, { once: true, passive: true })
    })
  }

  onMounted(() => {
    bindHoverPreload(document.body)
  })

  return { preload }
}
